<template>
    <div class="pl-5">
        <h1>Prestashop plugin</h1>
        <p style="font-style: italic; font-weight: bold;">NB! Prestashop plugin was updated on 2021-09-20 to new v2 version. Please update your plugin if you have older version of Prestashop plugin.</p>

        <p>
            Tarkpay offers a Payment plugin for Prestashop. This plugin is for Prestashop 1.7 and for Prestashop 1.6 is
            coming. Our payment plugin is developed only for EUR currency and allowed e-shop countries are EE, LV and
            LT.<br />
            You can download the plugin:
            <a href="/static/prestashop-plugin/tarkpay-prestashop-payment.zip">here</a>
        </p>
        <p>
            1.1 The first step is to login into admin panel and navigate to Modules->Module Manager.
        </p>
        <p>
            1.2 Choose "Upload a module" and upload tarkpay-prestashop-payment.zip
            <br />
            <img src="/static/img/prestashop-1.png" />
        </p>
        <p>
            1.3 If upload was successful then click "Configure". If theres not such button you must search for "tarkpay"
            in Module Manager.
            <br />
            <img src="/static/img/prestashop-2.png" />
        </p>
        <p>
            2. Fill inputs with correct data and hit "Save".
            <br />
            <img src="/static/img/prestashop-3.png" />
        </p>
        <p>
            3. Go to checkout and find out if everything works fine. The result should look similar to next picture.
            <br />
            <img src="/static/img/prestashop-4.png" />
        </p>
    </div>
</template>

<script>
export default {
    name: "prestashop-plugin-page"
};
</script>

<style scoped></style>
